import { FC } from 'react';
import { AlertDialog } from '@components/design-system';
import * as Styles from '@components/modals/styles';

export interface IUserBlock {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  username?: string;
}

export const UserBlock: FC<IUserBlock> = ({ username, open, onOpenChange }) => {
  const handleConfirm = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title="Block User"
      description={`${username} won't be able to find your profile. Versum won't let them know you blocked them.`}
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content />
    </AlertDialog>
  );
};
